import { Hero } from "../components/Hero";
import { Features } from "../components/Features";
import { Roadmap } from "../components/Roadmap";
import { Waitlist } from "../components/Waitlist";
import { Footer } from "../components/Footer";
import Simulator from "../components/Simulator";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Hero />
      <Features />
      <Simulator />
      <Roadmap />
      <Waitlist />
      <Footer /> 
    </div>
  );
}
